import { Component } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { AuthService } from '../../services/auth.service';
import { ActivatedRoute, Router } from '@angular/router';
import { catchError, forkJoin, map, merge, of, startWith, switchMap } from 'rxjs';

@Component({
  selector: 'app-login',
  imports: [ReactiveFormsModule],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss'
})
export class LoginComponent {

  loginForm: FormGroup;
  mensaje: string = '';
  returnUrl: string = '';

  constructor(private fb: FormBuilder, private authService: AuthService, private route: ActivatedRoute, private router: Router) {
    this.loginForm = this.fb.group({
      username: ['', Validators.required],
      password: ['', Validators.required]
    });
  }
  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      this.returnUrl = params['returnUrl'] ?? '';
    });
    this.authService.checkSession().subscribe((logged) => {
      if(logged && this.returnUrl === '') {
        this.router.navigate(['/admin/dashboard']);  
      } else if (logged && this.returnUrl !== '') {
        this.router.navigate([this.returnUrl]);
      }
    });
    // forkJoin({
    //   params: this.route.queryParams,
    //   logged: this.authService.checkSession()
    // }).subscribe(result => {
    //   if (result) {
    //     console.log(result);
    //   }
    // });

    // merge(this.route.queryParams, this.authService.checkSession())
    //   .pipe(
    //     map(data => {
    //       if (data === null) {
    //         return [];
    //       }
    //       return data.items;
    //     }),
    //   )
    //   .subscribe(data => { console.log(data) });

  }


  login() {
    this.authService
      .login({
        username: this.loginForm.controls['username'].value,
        password: this.loginForm.controls['password'].value
      }).subscribe({
        next: (resp) => {
          this.router.navigate([this.returnUrl ?? 'admin']);
          console.log(resp);
        },
        error: (error) => {
          console.log(error);
          this.mensaje = error.error.message;
        }
      });
  }

}
function observableOf(arg0: null): any {
  throw new Error('Function not implemented.');
}

